import { render, staticRenderFns } from "./v-datatable.vue?vue&type=template&id=001a0dfc&scoped=true&"
import script from "./v-datatable.vue?vue&type=script&lang=js&"
export * from "./v-datatable.vue?vue&type=script&lang=js&"
import style0 from "./v-datatable.vue?vue&type=style&index=0&id=001a0dfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a0dfc",
  null
  
)

export default component.exports